import { Box, Typography } from '@mui/material'
import HoverTooltip from '../../components/PageHelpers/HoverTooltip'
import UseTranslation from '../../hooks/UseTranslation'
import Pagination from '../../components/PageHelpers/Pagination'
import { importUsersRolesDetailsListPagination } from '../../redux/features/importUsersRolesDetails/importUsersRolesDetailsThunk'

const EmployeeListContainer = ({ store, customStyle }) => {
  const { t } = UseTranslation()

  const getModuleRoleLabel = (user) => {
    if (user?.module_name && user?.role_name) {
      return `${user?.module_name} - ${user?.role_name}`
    }
    if (user?.module_name) {
      return `${user?.module_name} - -- --`
    }
    if (user?.role_name) {
      return `-- -- - ${user?.role_name}`
    }
    return '-- -- --'
  }
  return (
    <Box sx={[styles.root, customStyle && customStyle]}>
      {store?.data?.map((user) => (
    <Box sx={styles.singleCard} key={user?.id}>
          <Box sx={styles.infoContainer}>
             <Box sx={styles.infoUnit}>
          <Typography component='span'>{`${t?.['E-Mail Address']}`}</Typography>
          <HoverTooltip title={user?.email || '-- -- --'}>
            <Typography variant='body1'>
              {user?.email || '-- -- --'}
            </Typography>
          </HoverTooltip>
        </Box>
        <Box sx={styles.nameUnit}>
          <Typography component='span'>{`${t?.Code}`}</Typography>
          <HoverTooltip title={user?.employee_code ? `#${user?.employee_code}` : '-- -- --'}>
            <Typography variant='body1'>
              {user?.employee_code ? `#${user?.employee_code}` : '-- -- --'}
            </Typography>
          </HoverTooltip>
        </Box>
        <Box sx={styles.infoUnit}>
          <Typography component='span'>{`${t?.['Module - Role']}`}</Typography>
          <HoverTooltip title={getModuleRoleLabel(user)}>
            <Typography variant='body1'>
              {getModuleRoleLabel(user)}
            </Typography>
          </HoverTooltip>
        </Box>

        <Box sx={[styles.infoUnit, styles.statusUnit]}>
          <Typography component='span'>{`${t?.Status}`}</Typography>
          <HoverTooltip title={user?.status?.name}>
            <Typography variant='body1'>
              <Box sx={{ color: user?.status?.color }}>{user?.status?.name}</Box>
            </Typography>
          </HoverTooltip>
            </Box>
            <Box sx={styles.infoUnit}>
          <Typography component='span'>{`${t?.['Comment / Reason']}`}</Typography>
          <HoverTooltip title={user?.fail_reason || '-- -- --'}>
            <Typography variant='body1'>
              {user?.fail_reason || '-- -- --'}
            </Typography>
          </HoverTooltip>
        </Box>
      </Box>
      </Box>
      ))
      }
       <Pagination
            store={store}
        actionToDispatch={importUsersRolesDetailsListPagination}
        pageSize={50}
      />
    </Box>
  )
}
const styles = {
  singleCard: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: 'white',
    fontSize: { xs: '14px', md: '16px' },
    padding: { xs: '10px 20px 10px 5px', md: '0px 20px' },
    margin: '10px 0px',
    borderRadius: '12px',
    boxShadow: '0 1px 3px 0 #efefef, 0 0 0 1px #f1f1f1',
    position: { xs: 'relative', md: 'unset' },
    height: { xs: 'auto', md: '110px' },
  },
  avatar: {
    display: 'flex',
    bgcolor: '#FFC542',
    color: 'white',
    height: { xs: '50px', md: '64px' },
    width: { xs: '50px', md: '64px' },
    mr: { xs: '0px', md: '29px' },
    textTransform: 'uppercase',
    fontWeight: 800,
    fontSize: { xs: '16px', md: '25px' },
  },
  infoContainer: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    width: '100%',
    marginLeft: { xs: '10px', md: '0px' },
    gap: '10px',
  },
  nameUnit: {
    display: 'flex',
    flexDirection: { xs: 'row', md: 'column' },
    justifyContent: { xs: 'flex-start', md: 'center' },
    maxWidth: { xs: '90%', sm: '200px', lg: '300px' },
    width: '100%',
    alignItems: 'flex-start',
    '& p': {
      fontSize: { xs: '14px', md: '16px' },
      whiteSpace: { xs: 'nowrap', md: 'nowrap' },
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontWeight: { xs: 600, md: 500 },
      width: 'fit-content',
      maxWidth: { xs: '90%', md: '95%' },
    },
    '& span': {
      display: { xs: 'none', md: 'block' },
      width: 'fit-content',
      fontSize: { xs: '14px', md: '16px' },
      opacity: '0.7',
      fontWeight: '500',
      color: 'text.hint',
      marginBottom: '10px',
      marginRight: { xs: '10px', md: '0px' },
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: { xs: 'nowrap', md: 'nowrap' },
    },
  },
  infoUnit: {
    display: 'flex',
    flexDirection: { xs: 'row', md: 'column' },
    justifyContent: { xs: 'flex-start', md: 'center' },
    maxWidth: { xs: '90%', sm: '200px', lg: '300px' },
    minWidth: { xs: '100px', md: '200px' },
    width: '100%',
    alignItems: 'flex-start',
    '& p': {
      fontSize: { xs: '12px', md: '16px' },
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: 'fit-content',
      maxWidth: { xs: '90%', md: '100%' },
    },
    '& span': {
      display: { xs: 'none', md: 'block' },
      width: 'fit-content',
      textAlign: 'left',
      fontSize: { xs: '12px', md: '14px' },
      opacity: '0.7',
      fontWeight: '500',
      color: 'text.hint',
      marginBottom: '10px',
      marginRight: { xs: '10px', md: '0px' },
    },
  },
  statusUnit: {
    alignItems: { xs: 'flex-start', md: 'center' },
  },
}
export default EmployeeListContainer
